import { Component, Prop, Vue } from 'vue-property-decorator'
import Node from '@/diagrams/models/node'

@Component
export default class ContextMenuButton extends Vue {

    @Prop()
    private node!: Node

    @Prop()
    private action!: string

    @Prop({ default: false })
    private archived!: boolean

    private fab = false

    get disabled() {
        if (this.archived) {
            return true
        }
        if (this.node) {
            if (this.node.isProject) {
                const enabled = this.action === 'projectTopicGroupsTopics'
                    || this.action === 'projectStakeholderGroupStakeholders'
                    || this.action === 'projectActionGroupsActions'
                return enabled === false
            }
            return this.node.isTopic
                || this.node.isProjectStakeholder
                || this.node.isAction
        }
        return false
    }
}
